import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {ArenaGameFilterEditor} from "../../arena-filters/filters/arena-game-filter-editor";
import {ISimpleStrategyFiltersEditorViewModel} from "./simple-strategy-filters-editor-view-model.interface";
import {Check} from "@sparkware/app-utils";
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";

export class SimpleStrategyFiltersEditor implements ISimpleStrategyFiltersEditorViewModel {
    constructor(private readonly filtersCategories: IArenaGameFiltersCategory[],
                private readonly services: IServiceFactoryExtended) {
        this._filters = this._createFiltersEditor();
    }

    private readonly _filters: ArenaGameFilterEditor[];

    get visibleFilters(): ArenaGameFilterEditor[] {
        return this._filters.filter(f => f.shouldBeDisplayed);
    }

    private _createFiltersEditor(): ArenaGameFilterEditor[] {
        const result: ArenaGameFilterEditor[] = [];

        this.filtersCategories.forEach(c => {
            c.availableFilters.forEach(f => {
                result.push(new ArenaGameFilterEditor(f));
            });
        });

        return this._sortFilters(result);
    }

    private _sortFilters(filters: ArenaGameFilterEditor[]): ArenaGameFilterEditor[] {

        //sorting the filters by the order in which they were defined in config.json
        const filtersConfigurations = this.services.arenas.getCurrentArena().filtersConfigurationMap;

        if(Check.isEmpty(filtersConfigurations)) {
            return filters;
        }

        return filters.sort((f1, f2) => filtersConfigurations[f1.id]?.index - filtersConfigurations[f2.id]?.index);
    }

    async applyFilters(): Promise<void> {
        await this.services.gamesFilter.applyFilters(this._filters.filter(f => f.on).map(f => f.id));
    }

}